__webpack_require__.p = "/visualisation-and-storytelling/";